define('lq/events/actions/processEngineScheduler',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function ProcessEngineScheduler(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ProcessEngineScheduler, EventAction);

    ProcessEngineScheduler.typeName = 'ProcessEngineScheduler';

    ProcessEngineScheduler.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    ProcessEngineScheduler.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'ProcessEngineScheduler',
            command: this.eventData.command
        };
    };

    ProcessEngineScheduler.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;

        var disabled = self.eventData.disabled;
        var ignoreErrors = self.eventData.ignoreErrors;
        var waitUntilReady = self.eventData.waitUntilReady;
        var schedulerUrl = self.eventData.schedulerUrl.trim().replace(/\/$/, '');
        var startTimeout = (parseInt(self.eventData.startTimeout) || 10000);
        var waitTimeout = (parseInt(self.eventData.waitTimeout) || 300000);
        var retryStartInterval = (parseInt(self.eventData.retryStartInterval) || 500);
        var initialWaitInterval = (parseInt(self.eventData.initialWaitInterval) || 0);
        var additionalWaitInterval = (parseInt(self.eventData.additionalWaitInterval) || 500);

        var started;
        var id;

        var afterCompleted = function () {
            if (waitUntilReady) {
                continuation();
            }
        };

        var completed = function () {
            self.triggerEventIfEnabledAndContinue('completed', afterCompleted, eventActionResponse.id);
        };

        var handleError = function (eventName, defaultMessage, eventArg) {
            if (self.eventIsEnabled(eventName)) {
                self.triggerEvent(eventName, afterCompleted, eventArg);
            } else if (ignoreErrors) {
                afterCompleted();
            }
            else {
                alert(defaultMessage);
            }
        }

        var retryWait = function (error) {
            var elapsed = new Date() - started;
            if (elapsed < waitTimeout)
                setTimeout(function () { wait(); }, additionalWaitInterval);
            else
                handleError('timedOutWaiting', 'Timed out waiting for process engine: ' + error, eventActionResponse.id)
        }

        var wait = function () {
            fetch(schedulerUrl + '/status/' + id, {
                method: 'GET',
                cache: 'no-store'
            })
                .then(function (response) {
                    if (response.status == 200) {
                        response.json()
                            .then(result => {
                                if (result.status == "success")
                                    completed();
                                else if (result.status == "failed")
                                    handleError('failed', 'Process engine failed: ' + result.error, eventActionResponse.id)
                                else if (result.status == "unknown") {
                                    // scheduler restarted
                                    started = new Date();
                                    start();
                                }
                                else
                                    retryWait(result.status);
                            })
                            .catch(function (error) {
                                retryWait(error);
                            })
                    }
                    else {
                        retryWait(response.statusText);
                    }
                })
                .catch(function (error) {
                    retryWait(error);
                });
        };

        var retryStart = function (error) {
            var elapsed = new Date() - started;
            if (elapsed < startTimeout)
                setTimeout(function () { start(); }, retryStartInterval);
            else
                handleError('timedOutStarting', 'Timed out starting process engine: ' + error, eventActionResponse.id);
        }

        var start = function () {
            fetch(schedulerUrl + '/start', {
                method: 'POST',
                body: eventActionResponse.ticket
            })
                .then(function (response) {
                    if (response.status == 200) {
                        if (waitUntilReady || self.eventIsEnabled('completed') || self.eventIsEnabled('failed')) {
                            response.json()
                                .then(result => {
                                    id = result.id;
                                    setTimeout(function () { wait(); }, initialWaitInterval);

                                })
                                .catch(function (error) {
                                    retryStart(error);
                                })
                        }
                        else {
                            afterCompleted();
                        }
                    }
                    else {
                        retryStart(response.statusText);
                    }
                })
                .catch(function (error) {
                    retryStart(error);
                });
        }

        var afterStarting = function () {
            if (!waitUntilReady) {
                continuation();
            }

            if (disabled) {
                completed();
            }
            else {
                started = new Date();
                start();
            }
        };

        self.triggerEventIfEnabledAndContinue('starting', afterStarting, eventActionResponse.id);
    };

    return ProcessEngineScheduler;
});
